import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Image, Popover } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import { MdAdd, MdSearch, MdOutlineContentCopy, MdEdit } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  FacebookIcon,
  FacebookShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { toast } from "react-toastify";
import deletepic from "../../assets/delete.svg";
import forwardpic from "../../assets/forward.svg";
import forwardGray from "../../assets/forward-gray.svg";
import MyVerticallyCenteredModal from "../../Components/DeleteModal/DeleteModal";
import Loader from "../../Components/Loader/Loader";
import Pagination from "../../Components/Pagination/Pagination";
import SearchBarResults from "../../Components/Search/SearchBarResults";
import { getCouponDeleteModelFlag } from "../../redux/DeleteModelFlagSlice";
import { DeleteCouponApi } from "../../Utils/Api/DeleteCouponApi";
import { DisableVoucherCouponApi } from "../../Utils/Api/DisableVoucherCoupon";
import { ManageCouponsApi } from "../../Utils/Api/ManageCoupons";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { RemoveSortkeys, userId } from "../../Utils/LocalStorage";
import FacebookShare from "../../Components/SocialShare/FacebookShare";
import WhatsappShare from "../../Components/SocialShare/WhatsappShare";
import { FormatDateShortMonth } from "../../Utils/FormatDateShortMonth";

const ManageCoupons = (props) => {
  const [manageCouponsData, setManageCoupons] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [deleteId, setDeleteID] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  const [loading, setLoading] = useState(false);
  const [eligibleFlag, setEligibleFlag] = useState(false);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [flag, setFlag] = useState({
    couponName: 0,
    expiryDate: 0,
    availableDate: 0,
    downloaded: 0,
    marketplace: 0,
  });

  const shareUrl = process.env.REACT_APP_COMMON_URL + "my-account/view-coupon";

  const uid = parseInt(userId());

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const ManageCouponsAPIHandler = async (searchVal, sortval, colName) => {
    if (colName) {
      localStorage.setItem("colName", colName);
    }
    if (sortval) {
      localStorage.setItem("sortval", sortval);
    }

    const ColName = localStorage.getItem("colName");
    const SortVal = parseInt(localStorage.getItem("sortval"));

    const val = {
      business_id: uid,
      limit: 10,
      offset: searchVal ? 0 : pageNumber,
      search_value: searchVal,
      column_name: ColName ? ColName : colName,
      sort_type: SortVal ? SortVal : sortval,
    };

    if (!val.sort_type && !val.column_name) {
      setLoading(true);
    }
    const CouponTableData = await ManageCouponsApi(val, () => {
      navigate("/");
    });
    console.log("CouponTableData", CouponTableData);
    if (CouponTableData.status === 429) {
      toast.error(CouponTableData.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(true);
    }
    if (!val.sort_type && !val.column_name) {
      setLoading(false);
    }
    setManageCoupons(CouponTableData.data);
    setTotalPageCount(CouponTableData.total_page_count);
    setEligibleFlag(CouponTableData.create_coupon_eligible);
    setLimit(CouponTableData.limit);
  };

  const handleDelete = async (flag) => {
    if (flag == true) {
      const val = {
        business_id: uid,
        coupon_id: deleteId,
      };

      setLoading(true);
      const filteredList = await DeleteCouponApi(val, () => {
        navigate("/");
      });
      if (filteredList === false) {
        toast.error(ServerError, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      } else {
        if (filteredList.success === true) {
          toast.success(filteredList.message, {
            position: "top-center",
            width: "500px",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          ManageCouponsAPIHandler();
          setLoading(false);
          setModalShow(false);
        } else if (filteredList.status === 429) {
          setLoading(true);
          toast.error(filteredList.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        } else {
          toast.error(filteredList.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setLoading(false);
        }
      }
    }
  };

  const DisableHandler = async (flag) => {
    if (flag === true) {
      const val = {
        checkvoucher_coupon: "coupon",
        product_id: deleteId,
        business_id: uid,
      };
      setLoading(true);
      const DisabledRes = await DisableVoucherCouponApi(val, () => {
        navigate("/");
      });
      if (DisabledRes === false) {
        toast.error(ServerError, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      } else {
        if (DisabledRes.success === true) {
          toast.success(DisabledRes.message, {
            position: "top-center",
            width: "500px",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          ManageCouponsAPIHandler();
          setLoading(false);
          setModalShow(false);
        } else if (DisabledRes.status === 429) {
          toast.error(DisabledRes.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setLoading(true);
        } else {
          toast.error(DisabledRes.message, {
            position: "top-center",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setLoading(false);
        }
      }
    }
  };

  const HandleSortCouponName = () => {
    if (flag.couponName === 0) {
      ManageCouponsAPIHandler(search, 1, "coupon_name");
      setFlag((ps) => {
        return { ...ps, couponName: 1 };
      });
    } else if (flag.couponName === 1) {
      ManageCouponsAPIHandler(search, 2, "coupon_name");
      setFlag((ps) => {
        return { ...ps, couponName: 2 };
      });
    } else {
      ManageCouponsAPIHandler(search, 0, "coupon_id");
      setFlag((ps) => {
        return { ...ps, couponName: 0 };
      });
    }
  };

  const HandleSortAvailableDate = () => {
    if (flag.availableDate === 0) {
      ManageCouponsAPIHandler(search, 1, "coupon_avail_until_date");
      setFlag((ps) => {
        return { ...ps, availableDate: 1 };
      });
    } else if (flag.availableDate === 1) {
      ManageCouponsAPIHandler(search, 2, "coupon_avail_until_date");
      setFlag((ps) => {
        return { ...ps, availableDate: 2 };
      });
    } else {
      ManageCouponsAPIHandler(search, 0, "coupon_id");
      setFlag((ps) => {
        return { ...ps, availableDate: 0 };
      });
    }
  };

  const HandleSortExpiryDate = () => {
    if (flag.expiryDate === 0) {
      ManageCouponsAPIHandler(search, 1, "coupon_end_date");
      setFlag((ps) => {
        return { ...ps, expiryDate: 1 };
      });
    } else if (flag.expiryDate === 1) {
      ManageCouponsAPIHandler(search, 2, "coupon_end_date");
      setFlag((ps) => {
        return { ...ps, expiryDate: 2 };
      });
    } else {
      ManageCouponsAPIHandler(search, 0, "coupon_id");
      setFlag((ps) => {
        return { ...ps, expiryDate: 0 };
      });
    }
  };

  const HandleSortDownloaded = () => {
    if (flag.downloaded === 0) {
      ManageCouponsAPIHandler(search, 1, "coupon_download_count");
      setFlag((ps) => {
        return { ...ps, downloaded: 1 };
      });
    } else if (flag.downloaded === 1) {
      ManageCouponsAPIHandler(search, 2, "coupon_download_count");
      setFlag((ps) => {
        return { ...ps, downloaded: 2 };
      });
    } else {
      ManageCouponsAPIHandler(search, 0, "coupon_id");
      setFlag((ps) => {
        return { ...ps, downloaded: 0 };
      });
    }
  };
  const HandleSortMarketplace = () => {
    if (flag.marketplace === 0) {
      ManageCouponsAPIHandler(search, 1, "marketplace");
      setFlag((ps) => {
        return { ...ps, marketplace: 1 };
      });
    } else if (flag.downloaded === 1) {
      ManageCouponsAPIHandler(search, 2, "marketplace");
      setFlag((ps) => {
        return { ...ps, marketplace: 2 };
      });
    } else {
      ManageCouponsAPIHandler(search, 0, "coupon_id");
      setFlag((ps) => {
        return { ...ps, marketplace: 0 };
      });
    }
  };

  //   if (flag.couponName === 0) {
  //     ManageCouponsAPIHandler(search, 1, "coupon_name");
  //     setFlag((ps) => {
  //       return { ...ps, couponName: 1 };
  //     });
  //   } else if (flag.couponName === 1) {
  //     ManageCouponsAPIHandler(search, 2, "coupon_name");
  //     setFlag((ps) => {
  //       return { ...ps, couponName: 2 };
  //     });
  //   } else {
  //     ManageCouponsAPIHandler(search, 0, "coupon_name");
  //     setFlag((ps) => {
  //       return { ...ps, couponName: 0 };
  //     });
  //   }
  // };

  const handleChange = (e) => {
    let val = e.target.value;
    setSearch(val.trim());
    if (!val) {
      ManageCouponsAPIHandler("");
    }
  };

  const CreateCouponHandler = (flag, id) => {
    if (eligibleFlag === true) {
      if (flag === "clone" && id !== null) {
        navigate(`/my-account/clone-coupon/${id.toString()}/true`);
      } else if (flag === "create") {
        navigate("/my-account/create-coupons");
      }
    } else {
      toast.error(
        "Hey there, you have exceeded the Coupon limit creation. Upgrade your subscription to create more coupons. Kindly refer to My Profile - Subscription page.",
        {
          position: "top-center",
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        },
      );
    }
  };

  const handleSearchClick = () => {
    ManageCouponsAPIHandler(search);
  };
  // enter-keyboard
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      ManageCouponsAPIHandler(search);
    }
  };
  const win = window.location.href;

  useEffect(() => {
    RemoveSortkeys();
  }, [win]);

  useEffect(() => {
    ManageCouponsAPIHandler();
    window.scrollTo(0, 0);
  }, [pageNumber]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="manage-vou-main pt-3 pb-3">
        <p className="page-maintitle pt-2">Manage Coupons</p>
        <div className="manage-vou">
          <InputGroup className="search-bar">
            <InputGroup.Text>
              <MdSearch />
              <Form.Control
                type="text"
                placeholder="Search"
                maxLength={200}
                onChange={handleChange}
                onKeyPress={handleKeypress}
              />
            </InputGroup.Text>
            <Form.Control />
            <Button variant="outline-secondary" onClick={handleSearchClick}>
              Search
            </Button>
          </InputGroup>
          <Button
            variant="primary"
            className="create-btn create-voucher-button"
            onClick={() => CreateCouponHandler("create", null)}
          >
            <MdAdd className="add-btn" /> Create Coupon
          </Button>
        </div>
      </div>
      <SearchBarResults SearchValue={search} />
      <div className="table-responsive-xl black-header">
        <div className="flex justify-end items-center gap-1">
          <MdOutlineContentCopy fill="#E66100" />
          <p>To copy/clone the coupon</p>
        </div>
        <table className="recentact-table mt-3 table ver-middle manage-vou-table man-coup-Table">
          <thead>
            <tr>
              {/* <th className="radio-colors"></th> */}
              <th>
                <Button
                  onClick={HandleSortCouponName}
                  style={{ marginLeft: "0" }}
                >
                  Coupon Name{" "}
                  {flag.couponName === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.couponName === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              {/* <th width="150px">
                Marketplace<Image loading="lazy" src={sortpic} className="sortimg"></Image>
              </th> */}
              <th>
                <Button
                  onClick={HandleSortAvailableDate}
                  style={{ margin: "auto" }}
                >
                  Available Until Date
                  {flag.availableDate === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.availableDate === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  onClick={HandleSortExpiryDate}
                  style={{ margin: "auto" }}
                >
                  Expiry Date{" "}
                  {flag.expiryDate === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.expiryDate === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              {/* <th>
                <Button onClick={HandleSortMarketplace}>
                  Marketplace{" "}
                  {flag.redeemed === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.redeemed === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th> */}
              <th>
                <Button
                  onClick={HandleSortDownloaded}
                  style={{ margin: "auto" }}
                >
                  Downloaded{" "}
                  {flag.downloaded === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.downloaded === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>

              <th
                className="action-main text-white"
                style={{ textAlign: "center", color: "#fff!important" }}
              >
                Status
              </th>
              <th
                className="action-main text-white"
                style={{ textAlign: "center", color: "#fff!important" }}
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {manageCouponsData?.length > 0 ? (
              manageCouponsData.map((data) => {
                return (
                  <tr
                    key={data.id}
                    className={data.is_active === 0 ? "disable" : ""}
                  >
                    {/* {data.is_active === 1 ? (
                      <td className="radio-colors">
                        <Image loading="lazy" src={greenradio}></Image>
                      </td>
                    ) : (
                      <td className="radio-colors">
                        <Image loading="lazy" src={redradio}></Image>
                      </td>
                    )} */}

                    <td
                      className="text-left blue-underline-text"
                      title={data.coupon_name}
                    >
                      <Link
                        to={`/my-account/view-coupon/${data.coupon_id.toString()}`}
                      >
                        {data.coupon_name}
                      </Link>
                    </td>
                    {/* <td>
                      <p className="text-limit-2" title={data.marketplace}>
                        {data.marketplace}
                      </p>
                    </td> */}
                    <td className="date-col" style={{ textAlign: "center" }}>
                      {FormatDateShortMonth(data.coupon_avail_until_date)}
                    </td>
                    <td className="date-col">
                      {FormatDateShortMonth(data.end_date)}
                    </td>
                    {/* <td>{data.marketplace}</td> */}
                    <td>{data.downloaded_count}</td>
                    <td>
                      {data?.coupon_status === "draft" ? "Draft" : "Published"}
                    </td>
                    <td>
                      <div className="action-img action-div">
                        <Link
                          to={`/my-account/edit-coupon/${data.coupon_id.toString()}`}
                          onClick={(e) => {
                            if (
                              data.coupon_status?.toLowerCase() ===
                                "published" ||
                              data.is_active === 0
                            ) {
                              e.preventDefault();
                            }
                          }}
                        >
                          <MdEdit
                            size={20}
                            fill={
                              data.coupon_status?.toLowerCase() ===
                                "published" || data.is_active === 0
                                ? "#ccc"
                                : "#E66100"
                            }
                            style={{
                              cursor:
                                data.coupon_status?.toLowerCase() ===
                                  "published" || data.is_active === 0
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            title="Edit"
                          />
                        </Link>
                        {data.is_active === 0 ? (
                          <>
                            {/* <Image loading="lazy" src={editpic}></Image> */}
                            <Image loading="lazy" src={deletepic}></Image>
                            <Image
                              loading="lazy"
                              src={forwardpic}
                              title="Share"
                            ></Image>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => {
                                setModalShow(true);
                                setDeleteID(data.coupon_id);
                                dispatch(
                                  getCouponDeleteModelFlag(data.downloaded),
                                );
                              }}
                              title="Delete"
                            >
                              <Image loading="lazy" src={deletepic}></Image>
                            </button>
                            {data?.coupon_status?.toLowerCase() === "draft" ? (
                              <Image
                                loading="lazy"
                                src={forwardGray}
                                title="Share"
                                cursor="not-allowed"
                                style={{ cursor: "not-allowed", opacity: 0.7 }}
                              ></Image>
                            ) : (
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                rootClose
                                overlay={
                                  <Popover
                                    id="popover-positioned-top"
                                    title="Share to:"
                                  >
                                    <FacebookShare
                                      shareUrl={data.product_share_url}
                                    />
                                    <WhatsappShare
                                      shareUrl={data.product_share_url}
                                    />
                                  </Popover>
                                }
                              >
                                <Image
                                  loading="lazy"
                                  src={forwardpic}
                                  style={{ cursor: "pointer" }}
                                  title="Share"
                                ></Image>
                              </OverlayTrigger>
                            )}
                          </>
                        )}
                        <MdOutlineContentCopy
                          fill="#E66100"
                          title="Clone"
                          onClick={() =>
                            CreateCouponHandler("clone", data.coupon_id)
                          }
                        />
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={7} className="text-center">
                  <p className="no-record">No records available!</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div>
        {totalPageCount > 10 ? (
          <Pagination
            TotalPageCount={totalPageCount}
            Limit={limit}
            SetPageNumber={setPageNumber}
          />
        ) : (
          <></>
        )}
      </div>
      <MyVerticallyCenteredModal
        handleDeletefuc={handleDelete}
        show={modalShow}
        handleDisablefuc={DisableHandler}
        onHide={() => setModalShow(false)}
        page={"coupon"}
      />
    </>
  );
};

export default ManageCoupons;
